// BeautySkin® Bundle Cart Logic
// assets/bs-bundle-cart.js

if (window.location.pathname !== '/') {

window.bsCart = {
  MASQUE_ID: 51509557821768,
  GLOWLIFT_ID: 51616939344200,

  bundles: {
    '1': {
      label: 'Commander — 49,99€',
      items: [{ id: 51509557821768, quantity: 1 }]
    },
    '2': {
      label: "Profiter de l'offre — 49,99€",
      items: [{ id: 51509557821768, quantity: 2 }]
    },
    '3': {
      label: 'Commander le Pack Duo — 119,99€',
      items: [
        { id: 51509557821768, quantity: 1 },
        { id: 51616939344200, quantity: 1 }
      ]
    }
  },

  addToCart: function(bundleId, btnEl) {
    var bundle = this.bundles[bundleId];
    if (!bundle) return;

    if (btnEl) {
      btnEl.classList.add('bs-btn-loading');
      btnEl.setAttribute('disabled', 'disabled');
    }

    var items = bundle.items.map(function(item) {
      return { id: item.id, quantity: item.quantity };
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.status && data.status !== 200) {
        console.error('Erreur:', data.description);
        return;
      }
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var bubbles = document.querySelectorAll('.cart-count-bubble span[aria-hidden]');
          bubbles.forEach(function(b) { b.textContent = cart.item_count; });
          var cartBubble = document.querySelector('.cart-count-bubble');
          if (cartBubble) cartBubble.removeAttribute('hidden');
          var cartBtn = document.getElementById('cart-icon-bubble');
          if (cartBtn) cartBtn.click();
        });

      if (btnEl) {
        btnEl.classList.remove('bs-btn-loading');
        btnEl.removeAttribute('disabled');
      }
    })
    .catch(function(err) {
      console.error('Erreur ajout panier:', err);
      if (btnEl) {
        btnEl.classList.remove('bs-btn-loading');
        btnEl.removeAttribute('disabled');
      }
    });
  }
};

} // end if not homepage